import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

import { AuthService, BlockAbstractComponent, ParserService } from '@gallaghercp/core-frontend';

import { SwiperComponent, SwiperConfigInterface } from '@gallaghercp/core-swiper';
import { Navigation, Scrollbar } from 'swiper';

@Component({
    selector: 'core-block-card-events',
    templateUrl: './block-card-events.component.html',
    styleUrl: './block-card-events.component.scss',
    standalone: false,
})
export class BlockCardEventsComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
    @ViewChild('swiperRef')
    swiperRef?: SwiperComponent;

    activeIndex = 0;
    expandedItems = new Set<number>();
    private expandedClassTimer?: ReturnType<typeof setTimeout>;

    get paginationPages(): number[] {
        const slidesPerView = window.innerWidth >= 768 ? 2 : 1;
        const count = Math.max(1, this.block.content.length - slidesPerView + 1);
        return Array.from({ length: count }, (_, i) => i);
    }

    @HostListener('window:resize')
    onResize(): void {
        // triggers change detection to recalculate paginationPages
    }

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        private el: ElementRef,
    ) {
        super(parser, auth);
    }

    toggleDescription(id: number, event: Event): void {
        event.preventDefault();
        if (this.expandedItems.has(id)) {
            this.expandedItems.delete(id);
            if (this.expandedItems.size === 0) {
                this.expandedClassTimer = setTimeout(() => this.setSwiperAlignment(false), 380);
            }
        } else {
            clearTimeout(this.expandedClassTimer);
            this.expandedItems.add(id);
            this.setSwiperAlignment(true);
        }
    }

    private setSwiperAlignment(flexStart: boolean): void {
        const wrapper: HTMLElement | null = this.el.nativeElement.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.style.alignItems = flexStart ? 'flex-start' : '';
        }
    }

    swiperConfig: SwiperConfigInterface = {
        modules: [Navigation, Scrollbar],
        slidesPerView: 1,
        spaceBetween: 25,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
        },
    };

    override ngOnInit(): void {
        super.ngOnInit();
    }

    ngAfterViewInit(): void {
        const slides: NodeListOf<HTMLElement> = this.el.nativeElement.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });
    }

    onSlideChange(index: number): void {
        this.activeIndex = index;
    }

    goToSlide(index: number): void {
        this.activeIndex = index;
        this.swiperRef?.directiveRef?.setIndex(index);
    }

    prev() {
        this.swiperRef?.directiveRef?.prevSlide();
    }

    next() {
        this.swiperRef?.directiveRef?.nextSlide();
    }
}
